'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  focused: _propTypes2.default.bool,
  theme: _propTypes2.default.object
};

var defaultProps = {
  focused: false
};

var base = function base(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.inputAutocomplete.option,
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight,
      textTransform = _theme$reactackle$com.textTransform,
      paddingY = _theme$reactackle$com.paddingY,
      paddingX = _theme$reactackle$com.paddingX,
      borderRadius = _theme$reactackle$com.borderRadius;


  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n    border-radius: ' + (0, _reactackleCore.getValueString)(borderRadius) + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    text-transform: ' + textTransform + ';\n  ';
};

var style = function style(_ref2) {
  var themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = theme.reactackle.components.inputAutocomplete.option.style;

  return '\n    color: ' + source.fontColor + ';\n    background-color: ' + source.backgroundColor + ';\n    font-weight: ' + source.fontWeight + ';\n    \n    &:hover {\n      color: ' + source.hover.fontColor + ';\n      background-color: ' + source.hover.backgroundColor + ';\n      font-weight: ' + source.hover.fontWeight + ';\n    }\n    \n    &:focus {\n      color: ' + source.focus.fontColor + ';\n      background-color: ' + source.focus.backgroundColor + ';\n      font-weight: ' + source.focus.fontWeight + ';\n    }    \n  ';
};

var focused = function focused(_ref3) {
  var themeFromProvider = _ref3.theme,
      focused = _ref3.focused;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = theme.reactackle.components.inputAutocomplete.option.style;

  return focused ? '\n      color: ' + source.focus.fontColor + ';\n      background-color: ' + source.focus.backgroundColor + ';\n      font-weight: ' + source.focus.fontWeight + ';  \n    ' : '';
};

var OptionStyled = exports.OptionStyled = _styledComponents2.default.li.withConfig({
  displayName: 'OptionStyled'
})(['cursor:pointer;', ';', ';', ';', ';'], base, style, focused, (0, _reactackleCore.transition)('color, background-color'));

OptionStyled.propTypes = propTypes;
OptionStyled.defaultProps = defaultProps;
OptionStyled.displayName = 'OptionStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-input-autocomplete/dist/styles/OptionStyled.js
// module id = 728
// module chunks = 0